<template>
  <page :title="title" :breadcrumb="breadcrumb" :load="doInit">
    <template slot="pageAction">
      <div class="actionBlock">
        <v-menu offset-y :min-width="250">
          <v-btn text color="secondary" v-on="on">
            More Links...
            <v-icon right>mdi-link</v-icon>
          </v-btn>
          <side-function-menu :items="sideFunction" @doClick="sideMenuClick"></side-function-menu>
        </v-menu>
      </div>
    </template>
    <v-card>
      <v-card-title v-if="newInsured">
        <span class="title">New Insured</span>
      </v-card-title>
      <v-card-text v-else>
        <v-container fluid grid-list-sm>
          <v-layout row wrap>
            <v-flex xs4>
              <v-subheader class="queryLabel">{{labels.insdRefNo}}</v-subheader>
              <div class="queryValue">{{insured.insdRefNo}}</div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <transition name="slide-x-transition" mode="out-in">
        <router-view :routerKey="routerKey"></router-view>
      </transition>
    </v-card>
  </page>
</template>

<script>
import SideFunctionMenu from '@/components/core/claimManagement/sideFunction/SideFunctionMenu'
import { mapGetters, mapActions } from 'vuex'
import routeMixin from '@/mixins/route'

export default {
  data() {
    return {
      labels: {
        insdRefNo: 'Insured Reference'
      },
      breadcrumb: [],
      sideMenu: [
        { name: 'reviewDetails', text: 'Details', icon: 'mdi-account' }
      ],
      sideFunction: [
        { text: 'Details', icon: 'mdi-account', iconColor: 'primary', params: { key: 'reviewDetails' } }
      ],
      routerKey: undefined,
      newInsured: false
    }
  },
  computed: {
    ...mapGetters([
      'derieveBreadcrumbByName',
      'checkAccess'
    ]),
    title() {
      if (this.newInsured) {
        return 'New Insured'
      } else {
        return 'Review Insured'
      }
    },
    insured() {
      return this.$store.state.adminInsured.insured
    }
  },
  watch: {
    '$store.state.adminInsured.insured.fullName': function(value) {
      return this.$store.state.adminInsured.insured.fullName
    }
  },
  methods: {
    ...mapActions([
      'insuredMenuInit'
    ]),
    async doInit() {
      if (this.insdRefNo === 'new') {
        this.newInsured = true
        this.routerKey = 'reviewDetails'
      } else {
        await this.insuredMenuInit(this.insdRefNo)
        this.routerKey = 'reviewDetails'
        this.sideFunction.push({ text: 'Current Portfolio', icon: 'mdi-folder-account', iconColor: 'primary', params: { key: 'currPortfolioMenu', params: { insdRefNo: this.insdRefNo, clientGrp: this.clientGrp } } })
        this.breadcrumb = this.derieveBreadcrumbByName('insureds')
      }
      this.breadcrumb = this.derieveBreadcrumbByName('insureds')
      this.breadcrumb.push({
        name: 'reviewDetails',
        text: this.title
      })
      // if (this.insdRefNo === 'new') {
      //   this.newInsured = true
      // } else {
      //   await this.insuredMenuInit(this.insdRefNo)
      //   this.sideMenu.push({ name: 'currPortfolioMenu', text: 'Current Portfolio', icon: 'mdi-folder-account' })
      //   this.breadcrumb = this.derieveBreadcrumbByName('insureds')
      // }
      // this.breadcrumb = this.derieveBreadcrumbByName('insureds')
      // this.breadcrumb.push({
      //   name: 'reviewDetails',
      //   text: this.title
      // })
    },
    sideMenuClick(data) {
      this.$router.push({ name: data.key, params: data.params })
    }
  },
  props: ['insdRefNo', 'clientGrp'],
  components: {
    SideFunctionMenu
  },
  mixins: [
    routeMixin
  ]
}
</script>

<style lang="scss">
@import "../../../assets/scss/accounting.scss";
</style>
